import { clear, get, set } from '../lib/adapters/storage';

const PERSIST_KEY = 'application';
const GLOBAL_KEY = 'global';
const ACCOUNTS_KEY = 'accounts';
const ACCOUNT_KEY = 'account';

export const getAccount = () => get([PERSIST_KEY, GLOBAL_KEY, ACCOUNT_KEY]);

const globalKeys = [ACCOUNT_KEY, 'uiDark'];
const accountKeys = [
  'dashboardId', 'dashboardFilter',
  'viewId', 'viewFilter', 'viewDuration',
  'advancedQuery',
];
function persistence(fn, key, value) {
  const k = Array.isArray(key) ? key : [key];
  if (accountKeys.includes(key)) {
    const account = getAccount();
    if (!account) {
      throw new Error(`Attempted to persist account key without account: ${key}`);
    }
    k.unshift(...[PERSIST_KEY, ACCOUNTS_KEY, account]);
  } else if (globalKeys.includes(key)) {
    k.unshift(...[PERSIST_KEY, GLOBAL_KEY]);
  } else {
    throw new TypeError(`Unknown persistence key: ${key}`);
  }
  return fn(k, value);
}

export function persist(key, value) {
  const fn = (value === null || value === undefined) ? clear : set;
  persistence(fn, key, value);
}
export function restore() {
  const keys = [...globalKeys];
  if (getAccount() !== null) {
    keys.push(...accountKeys);
  }
  return keys.reduce((r, k) => ({ ...r, [k]: persistence(get, k) }), {});
}

export const setAccount = (account) => persist(ACCOUNT_KEY, account);
export const clearAccount = () => persist(ACCOUNT_KEY, null);
